document.querySelectorAll('.pb-page').forEach(root=>{const main=root.querySelector('.pb-main img'),cap=root.querySelector('.pb-caption'),dialog=root.querySelector('.pb-viewer');if(!main||!dialog)return;root.querySelectorAll('.pb-thumbs button').forEach(b=>b.addEventListener('click',()=>{main.src=b.dataset.src;main.alt=b.dataset.label;cap.textContent=b.dataset.label;root.querySelectorAll('.pb-thumbs button').forEach(x=>x.classList.toggle('active',x===b));}));root.querySelector('.pb-main').addEventListener('click',()=>{dialog.querySelector('img').src=main.src;dialog.querySelector('img').alt=main.alt;dialog.showModal();});dialog.querySelector('button').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});});

// Redirect only after Shopify has rendered its successful customer-form response.
(() => {
  const form = document.getElementById('PortableBlackoutEarlyAccess');
  if (!form?.querySelector('.cl-prd-form__message.is-success')) return;
  const locale = window.location.pathname.match(/^\/([a-z]{2}-[a-z]{2})(?:\/|$)/i);
  const prefix = locale ? `/${locale[1]}` : '';
  let redirected = false;
  const redirect = () => {
    if (redirected) return;
    redirected = true;
    window.location.replace(`${prefix}/pages/subscription-confirmed`);
  };
  if (window.CozyerWaitlist) window.CozyerWaitlist.complete(form, redirect);
  else redirect();
})();
